import { render, staticRenderFns } from "./StartersPlaceholder.vue?vue&type=template&id=4899efbb&scoped=true"
import script from "./StartersPlaceholder.vue?vue&type=script&lang=js"
export * from "./StartersPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./StartersPlaceholder.vue?vue&type=style&index=0&id=4899efbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899efbb",
  null
  
)

export default component.exports